
import '@static/iconfont/iconfont.css';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { routerNames, documentTypeAllList, depponReimBurseType } from '@/common/js/const';
import regexpValid from '@/common/js/regexp.js';
import { getVATQrcodeContent, setDepponReimBurseType, getDepponReimBurseType } from '@/common/js/common.js';
import moment from 'moment'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import dateFormat from 'vux/src/tools/date/format.js'

export default {
name: routerNames.OrderInvoiceFollow,
directives: {
TransferDom,
},
components: {
Box,
Group,
Cell,
CellBox,
XHeader,
XButton,
XInput,
Datetime,
Previewer,
},
data() {
let currentDate = moment().format('YYYY-MM-DD');
return {
invoiceTitle: '',
invoiceTitlePlaceholder: '',
invoiceTip: '',
currentDate,
logoSrc: '',
qrMsg: '',
uniCode: '',
posDate: '',
amount: '',
merchant: '',
storeCode: '',
openId: '',
date: '',
mi: '',
disableInvoice: false,
imageSlide1: [
{
src: '',
msrc: '',
alt: '',
title: '',
pid: 'image-one',
},
],

h5SupportSaoYiSao: false,
isWechat: ____isWechatBrowser(),
};
},
created() {},

activated() {
var $self = this;

$self.merchant = $self.$route.query.merchant;
$self.storeCode = $self.$route.query.storeCode;
$self.openId = $self.$route.query.openId;
$self.logoSrc = '/xforce/static/merch/' + $self.merchant + '/logo.jpg';
$self.imageSlide1[0].src = '/xforce/static/merch/' + $self.merchant + '/help.png';
$self.imageSlide1[0].msrc = '/xforce/static/merch/' + $self.merchant + '/help.png';

if (this.merchant == 'Walmart') {
this.invoiceTitle = '小票订单号';
this.invoiceTitlePlaceholder = '请填写小票订单号';
this.invoiceTip = '如何查找小票订单号';
} else {
this.invoiceTitle = '小票TC号';
this.invoiceTitlePlaceholder = '请填写小票TC号';
this.invoiceTip = '如何查找TC号';
}

$self.getStoreInfo();
if ($self.merchant == 'Walmart') {
$self.queryMIAccount();
}
$self.getJsapiConfig();
},

/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
tips() {
var $self = this;
$self.$refs.imageSlidePreviewer.show(0);
return false;
},
getStoreInfo() {
var $self = this;
var params = {
groupFlag: $self.merchant,
storeCode: $self.storeCode,
};
$self.$webapi.getStoreConfig(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.logoSrc = '/xforce/static/merch/' + $self.merchant + '/' + res.data.result.logoPic + '.jpg';

if (res.data.result.subBand == 'Sam') {
$self.invoiceTip = '查看示例';
$self.imageSlide1[0].src = '/xforce/static/merch/' + $self.merchant + '/helpSam.png';
$self.imageSlide1[0].msrc = '/xforce/static/merch/' + $self.merchant + '/helpSam.png';
} else if (res.data.result.subBand == 'Super') {
$self.imageSlide1[0].src = '/xforce/static/merch/' + $self.merchant + '/helpSuper.png';
$self.imageSlide1[0].msrc = '/xforce/static/merch/' + $self.merchant + '/helpSuper.png';
} else {
$self.imageSlide1[0].src = '/xforce/static/merch/' + $self.merchant + '/help.png';
$self.imageSlide1[0].msrc = '/xforce/static/merch/' + $self.merchant + '/help.png';
}
}
});
},
queryMIAccount() {
var $self = this;
const param = {
dataMap: JSON.stringify({
groupFlag: $self.merchant,
storeCode: $self.storeCode,
invoiceType: 'ce',
}),
};

$self.$webapi.queryMIAccount(param).then(orderRes => {
$self.$clog(orderRes.data);
if (orderRes.data.status == 1) {
$self.mi = orderRes.data.result.miAccount;
if (orderRes.data.result.online === 0) {
$self.disableInvoice = false;
$self.$vux.alert.show({
title: '提示',
content: '因设备维护，暂时无法开具电子发票，请到门店开具纸质发票。',
onShow() {},
onHide() {},
});
}
} else if (orderRes.data.status == 2) {
$self.mi = '';
} else {
$self.disableInvoice = true;
$self.$vux.alert.show({
title: '提示',

content: orderRes.data.msg,
onShow() {},
onHide() {},
});
}
});
},
onInputBlur() {
var $self = this;
window.scroll(0, 0);
},







openInvoice(obj) {
var $self = this;
const unicode = {
dataMap: JSON.stringify({
uniCode: $self.uniCode,

date: $self.date,
unAccount: 'wechat',
groupFlag: $self.merchant,
storeCode: $self.storeCode,
posDate: dateFormat($self.posDate, 'YYYYMMDD'),
onlyOrder: 1,
}),
};
if ($self.posDate && $self.uniCode) {
$self.disableInvoice = true;
$self.$webapi.queryOrderByUniCode(unicode).then(orderRes => {
$self.$clog(orderRes.data);
if (orderRes.data.status == 1) {
$self.orderId = orderRes.data.orderId;
let date = orderRes.data.posDate;

var queryJSON = {
m: $self.merchant,

or: $self.uniCode,

d: date,
b: $self.storeCode,
mi: $self.mi,
};

$self.$router.replace({
path: '/orderInvoice/index',
query: queryJSON,
});
} else {
$self.orderId = -1;


this.$vux.alert.show({
title: '提示',
content: orderRes.data.msg,
onShow() {
console.log("Plugin: I'm showing");
},
onHide() {
console.log("Plugin: I'm hiding now");
},
});
}
$self.disableInvoice = false;
});
} else {
$self.$vux.alert.show({
title: '提示',
content: '必输项不能为空！',
onShow() {},
onHide() {},
});
}
},

getJsapiConfig() {
var $self = this;
if ($self.isWechat) {
$self.$webapi.getJsapiSign().then(res => {
window.wx.config({
beta: true,
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: [

'chooseImage',
'previewImage',
'uploadImage',
'downloadImage',

'scanQRCode',
'chooseInvoice',
],
});
});
}
},

saoyisao() {
var $self = this;
if ($self.isWechat) {

window.wx.ready(function() {
window.wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
desc: 'scanQRCode desc',
success: function(res) {
var str = res.resultStr;
if (str.indexOf(',') >= 0) {
var arr = str.split(',');
$self.uniCode = arr[1];
}
},
});
});
}
},
},
};
